import React from 'react';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import Moment from 'moment';

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="d-flex flex-row justify-content-between">
                <div>
                    <span>
                        &copy;{` ${Moment().year()} `}
                        <a href="https://www.leanact.de/">leanact GmbH</a>.{' '}
                        <IntlMessages id="footer.allRightsReserved" />.
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js